/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
import { Config } from '@backstage/config';

export const getPortalTitle = (configApiRef: Config) => {
  return (
    configApiRef.getOptionalString('app.title') || 'Internal Developer Portal'
  );
};

export const getOrgName = (configApiRef: Config) => {
  return configApiRef.getOptionalString('organization.name') || 'Baker Hughes';
};
